import React from 'react';

import { Block } from './Block';

export function InnerBlocks({ as = null, className = '', blocks = [], nowrap = false, ...rest }) {
  const list = blocks.map((block, key) => <Block as={as} key={key} data={block} />);

  return !nowrap ? (
    <div className={className} {...rest}>
      {rest.children}
      {list}
    </div>
  ) : (
    <>
      {rest.children}
      {list}
    </>
  );
}
